var render = function render(){var _vm=this,_c=_vm._self._c;return _c('action-popup',{attrs:{"value":_vm.value,"headline":`Clone ${_vm.OrgObjectType}`,"info":_vm.generateInfo(),"icon":_vm.generateIconName(),"actionLabel":"Clone","deletePopup":true},on:{"input":_vm.closePopup,"onAction":_vm.onAction}})
}
var staticRenderFns = []

export { render, staticRenderFns }